<template>
  <advice :color="`funds${funds.type}`">
    <v-layout row
              wrap>
      <v-flex xs12
              sm4>
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.parking') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">
          {{funds.parking.name}}
        </span>
      </v-flex>
      <v-flex xs12
              sm4>
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.amount') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">
          {{funds.absAmountPrettyFormat}}
        </span>
      </v-flex>
      <v-flex xs12
              sm4>
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.start') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">{{funds.reservation.startLocal |
          formatDateAsUtc}}</span>
      </v-flex>
      <v-flex xs12
              sm4>
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.end') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">{{funds.reservation.endLocal |
          formatDateAsUtc}}</span>
      </v-flex>
      <v-flex xs12
              sm4>
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.date') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">{{funds.dateCreatedLocal |
          formatDateAsUtc}}</span>
      </v-flex>
      <v-flex xs12
              sm4
              v-if="funds.company.id">
        <span class="body-1 mr-2 grey--text text--darken-1">{{ $t('fundsDetail.company') }}:</span>
        <span class="body-2"
              :class="{'right': $vuetify.breakpoint.xsOnly}">
          {{funds.company.name}}
        </span>
      </v-flex>
    </v-layout>
    <v-layout row
              wrap>
      <v-flex xs12
              class="mt-3">
        <v-btn @click="downloadTicket(true)"
               :loading="ticketEmailLoading"
               :disabled="ticketEmailLoading"
               outline
               icon
               color="primary">
          <v-icon>email</v-icon>
        </v-btn>
        <v-btn @click="downloadTicket(false)"
               :loading="ticketDowloadLoading"
               :disabled="ticketDowloadLoading"
               outline
               round
               icon
               color="primary">
          <v-icon>mdi mdi-download</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </advice>
</template>

<script>
import ticketService from '@/services/ticketService';
import manageErrorService from '@/services/manageErrorService';
import Advice from '@/components/commons/Advice';
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'FundsBooking',
  components: {
    [Advice.name]: Advice
  },
  props: ['funds'],
  computed: {
    username() {
      return store.state.user.username;
    }
  },
  data() {
    return {
      ticketEmailLoading: false,
      ticketDowloadLoading: false
    };
  },
  methods: {
    async downloadTicket(sendByEmail) {
      let params = {
        reservationId: this.funds.reservation.id
      };

      let results;
      let msg;
      if (sendByEmail) {
        this.ticketEmailLoading = true;
        results = await ticketService.sendEmail(params);
        msg = this.$i18n.t('ticket.toast.sendByEmail.success', { username: this.username });
      } else {
        this.ticketDowloadLoading = true;
        let filename = this.$i18n.t('ticket.filename');
        results = await ticketService.downloadFile(params, filename);
        msg = this.$i18n.t('ticket.toast.downloadFile.success');
      }

      if (results.error) {
        manageErrorService.handle(results.data);
        this.ticketEmailLoading = false;
        this.ticketDowloadLoading = false;
        return;
      }

      this.ticketEmailLoading = false;
      this.ticketDowloadLoading = false;

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: msg,
        type: 'success',
        doNotTranslate: true
      });
    }
  }
};
</script>
